export const mailMessages4 = [
  {
    title: "Stefan | Holy Code · stefan.nenadovic@holycode.com",
    snippet:
      "Jane, ti ćeš mi trebati malo duže, tako da ostani posle sastanka. Nešto moram da prođem s tobom. Stefan",
    time: "11:02 AM",
  },
  {
    title: "Vanredni Sastanak | Holy Code · stefan.nenadovic@holycode.com",
    snippet:
      "Pozdrav svima! Sutra imamo vanredni grupni sastanak koji počinje u 11h. Prisutnost je obavezna. Vidimo se sutra! Stefan",
    time: "11:00 AM",
  },
  {
    title: "Track Flow · no-reply@trackflow.app",
    snippet:
      "Ticket TF-9217 je ažuriran. Potrebno je tvoje odobrenje za merge API modula.",
    time: "09:30 AM",
  },
  {
    title: "Teodora | Holy Code · teodora.milosevic@holycode.com",
    snippet:
      "Hej, proveri zašto BuildForge build na staging-u puca. Izgleda da je problem u cache servisu.",
    time: "08:05 AM",
  },
  {
    title: "Tune Flow · digest@tuneflow.fm",
    snippet: "Nedeljni izbor muzike: Deep Focus Nights.",
    time: "07:08 AM",
  },
  {
    title: "Code Nest · alerts@codenest.dev",
    snippet: "Novi komentar na tvoju reviziju: Može li ovo elegantnije?",
    time: "Yesterday",
  },
  {
    title: "Aleksa | Holy Code · aleksa.vukovic@holycode.com",
    snippet: "Podsetnik: u 15h imamo brzi sync za novi billing mikroservis.",
    time: "Yesterday",
  },
  {
    title: "Skill Forge Academy · newsletter@skillforge.academy",
    snippet: "Kurs Mastering Async Architecture — 75% popusta danas.",
    time: "Yesterday",
  },
  {
    title: "Stay Finder Travel · offers@stayfinder.travel",
    snippet: "Vikend ponude — skriveni biseri Balkana.",
    time: "Last week",
  },
  {
    title: "Chat Hive · notifications@chathive.com",
    snippet: "Novi thread otvoren u Backend Guild kanalu.",
    time: "Last week",
  },
  {
    title: "Nova Bank · no-reply@novabank.rs",
    snippet: "Izvršena transakcija: 1.250 RSD — kartica završava na 22.",
    time: "Last week",
  },
  {
    title: "Build Forge · build@buildforge.io",
    snippet: "Build #5521 — SUCCESS nakon tvog poslednjeg commita.",
    time: "Last week",
  },
  {
    title: "Games Square · offers@gamesquare.gg",
    snippet: "Zimska rasprodaja počinje za 24 sata!",
    time: "Last week",
  },
  {
    title: "Nikola | Holy Code · nikola.dimitrijevic@holycode.com",
    snippet:
      "Poslao sam ti predlog nove arhitekture za auth modul. Javi utiske.",
    time: "Last week",
  },
  {
    title: "ProNetwork · updates@pronet.network",
    snippet: "14 ljudi je pogledalo tvoj profil ove nedelje.",
    time: "Last week",
  },
  {
    title: "Wikilayer · wiki@wikilayer.net",
    snippet: "Novi dokument objavljen: API Versioning Guidelines v3.",
    time: "Last week",
  },
  {
    title: "NimbusCloud · billing@nimbuscloud.io",
    snippet: "Vaša NimbusCloud pretplata je obnovljena. Račun je priložen.",
    time: "Last week",
  },
  {
    title: "DevOps | Holy Code · devops@holycode.com",
    snippet: "Planirani maintenance: subota u 01:00h — očekuj kratke prekide.",
    time: "Last week",
  },
  {
    title: "FourLoop · notif@forumloop.net",
    snippet: "Nova diskusija u temi Why Monoliths Still Matter.",
    time: "Last week",
  },
  {
    title: "Katarina | Holy Code · katarina.radic@holycode.com",
    snippet: "Klijent potvrdio: bug #3044 rešen. Svaka čast!",
    time: "Last week",
  },
  {
    title: "LiveCast TV · alerts@livecast.tv",
    snippet: "DevRel Insights upravo je počeo stream.",
    time: "Last week",
  },
  {
    title: "PayBridge · security@paybridge.com",
    snippet:
      "Zabeležena neuobičajena aktivnost. Molimo proverite Account Activity.",
    time: "Last week",
  },
  {
    title: "Stats | Holy Code · stats@holycode.com",
    snippet: "Nedeljni izveštaj: Aktivni korisnici +16.4% u poslednjih 7 dana.",
    time: "Last week",
  },
  {
    title: "Prime Pixel · promo@primepixel.games",
    snippet: "Vaš nalog je verifikovan! Možete pristupiti beta katalogu.",
    time: "Last week",
  },
  {
    title: "Nevena | Holy Code · nevena.stankovic@holycode.com",
    snippet:
      "Možeš li odobriti moj merge request do 17h? Treba za večerašnji release.",
    time: "Last week",
  },
  {
    title: "Vid Sphere · subscription@vidsphere.com",
    snippet: "Novi video: 5 najvećih grešaka u async kodu.",
    time: "Last week",
  },
  {
    title: "Calendar | Holy Code · calendar@holycode.com",
    snippet: "Podsetnik: Sprint planning — sutra u 10:00h.",
    time: "Last week",
  },
  {
    title: "SecurePass · support@securepass.tech",
    snippet: "Vaš OTP token ističe za 5 minuta. Završite verifikaciju.",
    time: "Last week",
  },
  {
    title: "Dragana | Holy Code · dragana.pavlovic@holycode.com",
    snippet:
      "Treba mi tvoja procena — koliko sati je potrebno za novi refactor task?",
    time: "Last week",
  },
];

export const incomingMails4 = [
  {
    title: "temp-user12@sendquickmail.me",
    snippet: "Dobro smo se zavozali?",
    time: "11:03 AM",
  },
  {
    title: "temp-user12@sendquickmail.me",
    snippet: "Znam ko si. A uskoro će znati i svi.",
    time: "11:04 AM",
  },
  {
    title: "temp-user12@sendquickmail.me",
    snippet: "Vidimo se sutra. ;)",
    time: "11:04 AM",
  },
];
